import React from 'react';
import styles from './Header.module.scss';
import StatisticsIcon from '../../shared/Icons/StatisticsIcon/StatisticsIcon';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getStatisticsUrl } from '../../../utils/render';
import { getEventsUrl } from '../../../utils/helpers';
import { clearEventDetails } from '../../../store/actions/eventDetails';

const Header = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const eventDetails = useSelector(state => state.eventDetails.event);
    const { isESports } = useSelector(state => state.sportEvents);

    const { categoryName, leagueName } = eventDetails;

    const closeAllMarkets = () => {
        const redirectUrl = getEventsUrl({ event: eventDetails });
        dispatch(clearEventDetails());
        history.push(redirectUrl);
    };

    const currentSeasonId = eventDetails.currentSeasonId || '';
    let seasonId = currentSeasonId?.split(':');
    seasonId = seasonId[seasonId.length - 1];
    let eventId = eventDetails.id?.replace('1:', '');
    let homeTeamId = eventDetails.teams?.homeCompetitorId?.split(':');
    homeTeamId = homeTeamId[homeTeamId.length - 1];
    let awayTeamId = eventDetails.teams?.awayCompetitorId?.split(':');
    awayTeamId = awayTeamId[awayTeamId.length - 1];

    return (
        <div className={styles.headerWrap}>
            <div className={styles.details}>
                {!isESports && (
                    <a
                        href={getStatisticsUrl({
                            eventId,
                            seasonId,
                            homeTeamId,
                            awayTeamId,
                        })}
                        target={'_blank'}
                        className={styles.detailsBtn}
                    >
                        <StatisticsIcon />
                    </a>
                )}
                <button className={`${styles.detailsBtn} icon-info`} />
                <div>{categoryName} /</div>
                <div className={'m-l-1'}>{leagueName}</div>
            </div>

            <button className={styles.closeBtn} onClick={closeAllMarkets}>
                <i className='icon-close-thin' />
            </button>
        </div>
    );
};

export default Header;
